import * as Typings from '../typings'
import {
  BRAND_LIST,
  Countries,
  CountryLanguageSwitcher,
  Languages,
} from '../../typings'

const IndonesiaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'id',

  LONG_NAME: 'Indonesia',
  SHORT_NAME: 'ID',

  DISPLAY_COUNTRY: 'Indonesia',

  LANGUAGES: {
    EN: 'en',
    ID: 'id',
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Indonesia (English)',
      TERMS_OF_USE_URL:
        'https://faq-id.uniqlo.com/articles/en_US/FAQ/UQID-TERMS-OF-USE',
      PRIVACY_POLICY_URL:
        'https://faq-id.uniqlo.com/pkb_Home_UQ_ID?id=kA32t000000Gmjz&l=en_US&c=category_uq_sg_my%3AUQID_PH2_C5_3&fs=Search&pn=1',
      HOME_PAGE_URL: 'https://uniqlo.com/id/en/',
      CONTACT_US_URL: 'https://faq-id.uniqlo.com/pkb_Home_UQ_ID?l=en_US',
    },
    [Languages.ID]: {
      LANGUAGE_CODE: 'id',
      DISPLAY_NAME: 'Bahasa Indonesia',
      TERMS_OF_USE_URL:
        'https://faq-id.uniqlo.com/pkb_Home_UQ_ID?id=kA32t000000Gmju&l=in&fs=Search&pn=1',
      PRIVACY_POLICY_URL:
        'https://faq-id.uniqlo.com/pkb_Home_UQ_ID?id=kA32t000000Gmjz&l=in&fs=Search&pn=1',
      HOME_PAGE_URL: 'https://www.uniqlo.com/id/id/',
      CONTACT_US_URL: 'https://faq-id.uniqlo.com/pkb_Home_UQ_ID?l=in',
    },
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: -0.7893,
    INITIAL_LONGITUDE: 113.9213,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  MAP_URL: 'https://www.uniqlo.com/id/shop/',
  // MAP_MOBILE_URL: '',

  POSTCODE_FORMAT: /[0-9]{5}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  LANGUAGE_OPTIONS: {
    [`${Countries.ID}/${Languages.ID}`]: {
      lid: `text_locale_id`,
      label: `#{PLACEHOLDER_COUNTRY}`,
    },
    [`${Countries.ID}/${Languages.EN}`]: {
      lid: `text_locale_en`,
      label: `#{PLACEHOLDER_COUNTRY}`,
    },
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default IndonesiaLocale
